import React from 'react';

// Utils
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../store/AppContext';
import withAuth from '../utils/hocs/withAuth';
import withSidebar from '../utils/hocs/withSidebar';
import SCOPE from '../utils/gate/scope';
import withPermission from '../utils/hocs/withPermission';
import adminTypes from '../constants/adminTypes';

// Components
import PageWrapper from '../components/layout/PageWrapper/PageWrapper';
import AdministrationPlatform from '../components/views/platform/Administration/Administration';
import AdministrationEstablishment from '../components/views/establishment/Administration/Administration';

function Admin() {
  const { t } = useTranslation();

  return (
    <PageWrapper
      title={t('admin.title')}
      hasWhiteWrapper
    >
      <AdministrationByAdminType />
    </PageWrapper>
  );
}

function AdministrationByAdminType() {
  const [{ adminType }] = useAppContext();

  const getComponent = () => {
    switch (adminType) {
      case adminTypes.platform:
        return <AdministrationPlatform />;
      case adminTypes.establishment:
        return <AdministrationEstablishment />;
      default:
        return null;
    }
  };

  return getComponent();
}

export default withAuth(
  withPermission(
    withSidebar(Admin),
    {
      scopes: [
        SCOPE.get_pla_adminAccount,
        SCOPE.get_est_adminAccount,
        SCOPE.get_ownEst_adminAccount,
      ],
    },
  ),
);
